import React, { Component } from "react";
import { Redirect } from 'react-router';
import PropTypes from "prop-types";
import Version from "version";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';


// @material-ui/icons
import Mobile from "@material-ui/icons/PhoneIphone";
import LockOutline from "@material-ui/icons/Lock";
// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import ButtonX from "components/CustomButtons/Button";
import Button from '@material-ui/core/Button';
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardFooter from "components/Card/CardFooter";
import Footer from "components/Footer/Footer";
import Snackbar from "components/Snackbar/Snackbar";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import { Offline, Online } from "react-detect-offline";
import ReactGA from 'react-ga';
import LinearProgress from '@material-ui/core/LinearProgress';

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import QRCode from 'qrcode.react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
// dotNetify
import dotnetify from 'dotnetify';
import * as rdd from 'react-device-detect';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Alert from '@material-ui/lab/Alert';
//Images
import Logo from "assets/img/Logo.png";
import bankid from "assets/img/bankid.png";
import Board from "assets/img/chalkboard_empty.svg";
//import bgImage from "assets/img/background.jpg";
//Authorization
import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import theme from 'theme';
var reactPlugin = new ReactPlugin();
const MySwal = withReactContent(Swal);

const BankIdButton = withStyles({
    root: {
        backgroundColor: '#225971',
        color: '#FFF',
        '&:hover': {
            backgroundColor: '#469CBE',
            color: '#FFF',
        },
        '&:active': {
            backgroundColor: '#469CBE',
            color: '#FFF',
        },
        '&:visited': {
            backgroundColor: '#225971',
            color: '#FFF',
        },
        '&:focus': {
            backgroundColor: '#469CBE',
            color: '#FFF',
        },
    },
})(Button);

function LoginMobileNumber(props) {
    const classes = props.classes;
    const t = props.t;
    const password = props.password;
    const state = props.state;
    const usernameInput = props.usernameInput;
    const passwordInput = props.passwordInput;
    const navigateTo = props.navigateTo;
    const hasLocalStorage = props.hasLocalStorage;
    const handleChange = props.handleChange;
    const changeUsername = props.changeUsername;
    const changePassword = props.changePassword;
    return (
        <div>
            <CardBody style={{ padding: '0px' }}>
                <Offline>
                    {t('selfcare:info.offline')}
                </Offline>
                <Online>
                    <FormControl fullWidth error={state.usernameErrorText !== ''} className={classes.margin}>
                        <InputLabel
                            classes={{
                                root: classes.cssLabel,
                                focused: classes.cssFocused,
                            }}
                            htmlFor="username"
                        >
                            {t('selfcare:input.mobilenumber')}
                        </InputLabel>
                        <Input
                            onBlur={() => { window.scrollTo(0, 0); } }
                            classes={{ underline: classes.cssUnderline }}
                            id="username"
                            onChange={(event) => { changeUsername(event.target.value) }}
                            type="tel"
                            inputRef={usernameInput}
                            autoFocus
                            disabled={state.rememberMe || state.dialogDisabled}
                            value={state.username}
                            color="secondary"
                            endAdornment={
                                <InputAdornment position="end">
                                    <Mobile className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            }
                        />
                        <FormHelperText id="username-error-text">{state.usernameErrorText}</FormHelperText>
                    </FormControl>
                    <FormControl fullWidth error={state.passwordErrorText !== ''} className={classes.margin}>
                        <InputLabel
                            classes={{
                                root: classes.cssLabel,
                                focused: classes.cssFocused,
                            }}
                            htmlFor="password"
                        >
                            {t('selfcare:input.password')}
                        </InputLabel>
                        <Input
                            onBlur={() => { window.scrollTo(0, 0); }}
                            classes={{
                                underline: classes.cssUnderline
                            }}
                            id="password"
                            onChange={event => {
                                changePassword(event.target.value)
                            }}
                            type="password"
                            inputRef={passwordInput}
                            disabled={state.rememberMe || state.dialogDisabled}
                            value={password}
                            color="secondary"
                            endAdornment={
                                <InputAdornment position="end">
                                    <LockOutline
                                        className={classes.inputAdornmentIcon}
                                    />
                                </InputAdornment>
                            }
                        />
                        <FormHelperText id="password-error-text">{state.passwordErrorText}</FormHelperText>
                    </FormControl>
                    {hasLocalStorage() ?
                        <FormControlLabel className={classes.switch}
                            control={
                                <Switch
                                    checked={state.rememberMeChecked}
                                    onChange={handleChange('rememberMeChecked')}
                                    value="rememberMe"
                                    color="secondary"
                                />
                            }
                            label={t('selfcare:label.remember')}
                            disabled={state.dialogDisabled}
                        /> : null}
                </Online>
            </CardBody>
            <CardFooter style={{ marginLeft: '0px', marginRight: '0px' }} className={classes.justifyContentCenter}>
                <Online>
                    <div className={classes.wrapper}>
                        <ButtonX type="submit" variant="contained" color="rose" size="lg" fullWidth disabled={state.dialogDisabled} style={{ marginTop: '15px' }}>
                            {t('selfcare:button.login')}
                        </ButtonX>
                        {state.loading && <CircularProgress size={36} className={classes.buttonProgress} />}
                        <ButtonX variant="contained" size="lg" fullWidth onClick={() => { navigateTo('/new-password'); }} disabled={state.dialogDisabled}>
                            {t('selfcare:button.register')}
                        </ButtonX>
                    </div>
                </Online>
            </CardFooter></div>);
}


export class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.vm = dotnetify.react.connect("Login", this,
            { headers: { ClientVersion: Version.getVersion() } }
        );
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);
        this.usernameInput = React.createRef();
        this.passwordInput = React.createRef();

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            password: '',
            dialogDisabled: false,
            snackbarOpen: false,
            snackbarMessage: '',
            rememberMe: false,
            rememberMeChecked: false,
            loading: false,
            redirect: false,
            usernameErrorText: '',
            passwordErrorText: '',
            username: '',
            InformationDialogOpen: false,
            BankIDStep: 'start',
            tab1Disabled: false,
            tabIndex: 0,
            failureText: null,
            startMessageText: null,
        };
    }
    componentDidMount() {
        //window.updateAvailable = () => {
        //    window.appInsights.trackTrace({ message: 'updateAvailable() called => Redirect to bounceback' });
        //    console.log("updateAvailable called => Redirect to bounceback");
        //    window.location.href = "https://bounceback.azurewebsites.net/index.html";
        //};
        const data = 'Client: ' + Version.getVersion();
        ReactGA.event({
            category: 'Version',
            action: data
        });
        fetch('/api/security/clientinfo')
            .then(response => response.json())
            .then(res => {
                try {
                    if (res.version !== Version.getVersion()) {
                        window.appInsights.trackTrace({ message: 'New version, current: ' + Version.getVersion() + ' new version: ' + res.version });
                        //if (sessionStorage.getItem('action') === 'reload') {
                        //    window.appInsights.trackTrace({ message: "Returned after bounce and forcing reload... waittime: " + sessionStorage.waitTime });
                        //    sessionStorage.removeItem('action');
                        //    window.location.reload();
                        //}
                        //this.setState({ Upgrade: true });
                        //this.setState({ cardAnimaton: "" });
                        //if (window.ServiceWorkerRegistration && window.ServiceWorkerRegistration.waiting) {
                        //    window.appInsights.trackTrace({ message: 'Registration waiting, sending SkipWaiting message.' });
                        //    window.ServiceWorkerRegistration.waiting.postMessage('skipWaiting');
                        //}

                        //if (sessionStorage.getItem('waitTime') === null) {
                        //    sessionStorage.waitTime = 3000;
                        //} else {
                        //    sessionStorage.waitTime = Number(sessionStorage.waitTime) + 3000;
                        //}
                        //setTimeout(function () {
                        //    if (sessionStorage.getItem('waitTime') === '3000') {
                        //        sessionStorage.setItem('action', 'reload');
                        //    }
                        //    window.appInsights.trackTrace({ message: "Redirect to bouceback after timeout, waitTime: " + sessionStorage.waitTime });
                        //    window.location.href = "https://bounceback.azurewebsites.net/index.html";
                        //}, Number(sessionStorage.waitTime));
                        this.init();
                    }
                    else
                        this.init();
                } catch (err) {
                    window.appInsights.trackTrace({ message: "Exception caught: " + err.message }); 
                }
            });
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        //Version checker
        if (nextState.ServerVersion && !this.state.ServerVersion) {
            const data = 'Client: ' + Version.getVersion() + " Server: " + nextState.ServerVersion;
            ReactGA.event({
                category: 'Version',
                action: data
            });
        }
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            setTimeout(
                function () {
                    //this.setState({ disabledAnimation: "" });
                },
                100
            );
        }
        if (nextState.StateName && !this.state.StateName) {
            setTimeout(
                function () {
                    this.setState({ [nextState.StateName]: nextState.StateValue });
                }.bind(this),
                5
            );
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        if (nextState.Message.OpenUrl) {
                            this.openExternalDialog(nextState.Message.OpenUrl);
                        }
                        if (nextState.Message.RedirectToUrl) {
                            this.setState({ redirect: true, toUrl: nextState.Message.RedirectToUrl });
                        }
                    });
                }.bind(this),
                10
            );
        }
        if (nextState.BankIDUrlSchema && !this.state.BankIDUrlSchema && rdd.isIOS && this.state.BankIDStep === 'local') {
            window.location.href = nextState.BankIDUrlSchema;
        }
        if (nextState.BankIDUrlSchema && !this.state.BankIDUrlSchema && rdd.isAndroid && this.state.BankIDStep === 'local') {
            window.location.href = nextState.BankIDUrlSchema;
        }
        if (nextState.Login && !this.state.Login) {
            const { onAuthenticated } = this.props;
            auth.signIn(nextState.Login.username, nextState.Login.password)
                .then(_ => {
                    this.setState({ loading: false });
                    ReactGA.event({
                        category: 'Navigation',
                        action: 'BankID login',
                    });
                    onAuthenticated();
                })
                .catch(error => {
                    this.setState({ Hidden: false });
                    this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                    this.shake();
                    this.setState({ dialogDisabled: false });
                    this.setState({ loading: false });
                    this.setState({ rememberMeChecked: false });
                    this.setState({ rememberMe: false });
                    this.setState({ focusObj: this.usernameInput.current });
                });
        }
        if (nextState.DebugLog !== this.state.DebugLog) {
            console.log(nextState.DebugLog);
        }
    }
    componentDidUpdate() {
        if (this.state.focusObj) {
            this.state.focusObj.focus();
            setTimeout(
                function () {
                    this.setState({ focusObj: null });
                }.bind(this),
                100
            );
        }
    }
    componentWillUnmount() {
        this.vm.$destroy();
        window.updateAvailable = undefined;
        try {
            delete window.updateAvailable;
        } catch (e) {
            //
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.Hidden) {
            return false;
        }
        return true;
    }

    init = () => {
        this.setState({ Upgrade: false });

        if (this.checkCRMLogin()) {
            return;
        }
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        this.checkAutoLogin();
        this.initCheck();
    }
    changeUsername = (value) => {
        this.setState({ usernameErrorText: '', username: value });
    }
    changePassword = (value) => {
        this.setState({ password: value, passwordErrorText: '' });
    }
    checkCRMLogin = () => {
        var ticket = this.getParameterByName("ticket");
        if (!ticket)
            return false;
        //window.updateAvailable = () => {
        //    window.location.reload(true);
        //};

        const { onAuthenticated } = this.props;

        this.setState({ error: null, dialogDisabled: true, loading: true });

        auth.signIn("ticket:" + ticket, 'password')
            .then(_ => {
                this.setState({ loading: false });
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Login CRM',
                });
                onAuthenticated();
            })
            .catch(error => {
                this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                this.shake();
                this.setState({ dialogDisabled: false });
                this.setState({ loading: false });
                this.setState({ focusObj: this.usernameInput.current });
                this.setState({ rememberMeChecked: false });
                this.setState({ rememberMe: false });
            });
        return true;
    }
    checkAutoLogin = () => {
        if (this.hasLocalStorage() && window.localStorage.chRememberMe && this.getParameterByName('autologin') === "1") {
            this.setState({ Hidden: true });
            //window.updateAvailable = () => {
            //    window.location.reload(true);
            //};
            const { onAuthenticated } = this.props;
            let password = window.localStorage.getItem('chPassword');
            let user = window.localStorage.getItem('chUsername');
            this.dispatchState({
                Validate: { username: user, password: password }
            });
            auth.signIn(user, password)
                .then(_ => {
                    this.setState({ loading: false });
                    ReactGA.event({
                        category: 'Navigation',
                        action: 'Auto login',
                    });
                    onAuthenticated();
                })
                .catch(error => {
                    this.setState({ Hidden: false });
                    this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                    this.shake();
                    this.setState({ dialogDisabled: false });
                    this.setState({ loading: false });
                    this.setState({ rememberMeChecked: false });
                    this.setState({ rememberMe: false });
                    this.setState({ focusObj: this.usernameInput.current });
                });
        }
    }
    getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }
    updateHookup = () => {
    }

    hideAlert = () => {
        this.setState({
            alert: null
        });
    }

    initCheck = () => {
        if (this.hasLocalStorage() && window.localStorage.chRememberMe) {
            this.setState({ username: window.localStorage.getItem('chUsername'), password: window.localStorage.getItem('chPassword'), rememberMe: true, rememberMeChecked: true });
        }
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
        if (name === "rememberMeChecked" && !event.target.checked) {
            window.localStorage.removeItem('chRememberMe');
            window.localStorage.removeItem('chUsername');
            window.localStorage.removeItem('chPassword');
            this.setState({ rememberMe: false, user: '', password: '' });
        }

    }

    hasLocalStorage = function () {
        try {
            window.localStorage.setItem("__test", "data");
            window.localStorage.removeItem("__test");
        } catch (e) {
            return false;
        }
        return true;
    }

    validate = function () {
        if (this.state.username === '') {
            this.setState({ usernameErrorText: this.props.t('selfcare:error.mobilenumberrequired'), focusObj: this.usernameInput.current });
            return false;
        }
        if (!this.isMobileNumber(this.state.username)) {
            this.setState({ usernameErrorText: this.props.t('selfcare:error.mobilenumberinvalid'), focusObj: this.usernameInput.current });
            return false;
        }
        if (this.state.password === '') {
            this.setState({ passwordErrorText: this.props.t('selfcare:error.passwordrequired'), focusObj: this.passwordInput.current });
            return false;
        }
        return true;
    }

    isMobileNumber = function (msisdn) {
        msisdn = msisdn.replace(/\s+/g, '');
        var locale = process.env.REACT_APP_DEFAULTLOCALE;
        switch (locale.toLowerCase()) {
            case "nb-no":
                if (msisdn.length !== 8 && msisdn.length !== 12)
                    return false;
                return true;
            case "sv-se":
                if (msisdn.length !== 10 && msisdn.length !== 14)
                    return false;
                return true;
            default:
                if (msisdn.length !== 8 && msisdn.length !== 12)
                    return false;
                return true;
        }
    }
    navigateTo = url => {
        this.setState({
            toUrl: url,
            redirect: true
        });
    }

    handleLogin = e => {
        if (e)
            e.preventDefault();
        const { onAuthenticated } = this.props;
        let { password } = this.state;
        let user = this.state.username;
        this.dispatchState({
            Validate: { username: user, password: password }
        });
        if (!this.validate()) {
            this.shake();
            return;
        }

        this.setState({ error: null, dialogDisabled: true, loading: true });

        auth.signIn(user, password, null, this.state.rememberMeChecked)
            .then(_ => {
                if (this.state.rememberMeChecked && this.hasLocalStorage() && !window.localStorage.chRememberMe) {
                    window.localStorage.setItem('chRememberMe', true);
                    window.localStorage.setItem('chUsername', user);
                    window.localStorage.setItem('chPassword', '');
                }
                this.setState({ loading: false });
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Login',
                });
                onAuthenticated();
            })
            .catch(error => {
                this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                this.shake();
                this.setState({ dialogDisabled: false });
                this.setState({ loading: false });
                this.setState({ focusObj: this.usernameInput.current });
                this.setState({ rememberMeChecked: false });
                this.setState({ rememberMe: false });
            });
    }
    shake = () => {
        this.setState({ cardAnimaton: "cardShake" });
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }

    handleInformationDialogClose = () => {
        this.setState({ InformationDialogOpen: false });
        window.localStorage.setItem('NewSelfcareInfoViewed', true);
    }
    indexChanged = (index) => {
        if (index === this.state.index)
            return;
        this.setState({ tabIndex: index });
        switch (index) {
            case 0:
                this.dispatchState({ CancelBankID: true });
                //this.setState({ tabIndex: 0 });
                break;
            case 1:
                //var returnUrl;
                //if (rdd.isIOS) {
                //    returnUrl = window.location.href;
                //} else {
                //    returnUrl = "null";
                //}
                //this.dispatchState({ InitBankID: returnUrl });
                //this.setState({ BankIDBuzy: true, dialogDisabled: true, tabIndex: index });
                break;
        }

    }

    initBankIDLocal = () => {
        var returnUrl;
        if (rdd.isIOS) {
            if (rdd.isSafari) {
                returnUrl = window.location.protocol + "//" + window.location.host + "/";
            } else if (rdd.isChrome) {
                returnUrl = "googlechromes://";
            } else if (rdd.isFirefox) {
                returnUrl = "firefox:://";
            } else if (rdd.isEdge || rdd.isEdgeChromium) {
                returnUrl = "microsoft-edge-https://";
            } else {
                returnUrl = "null";
            }
        } else {
            returnUrl = "null";
        }
        this.dispatchState({ InitBankID: { returnUrl: returnUrl, type: 'local' } });
        this.setState({ BankIDBuzy: true, dialogDisabled: true, tab1Disabled: true, BankIDStep: 'local' });
    }
    initBankIDOtherDevice = () => {
        var returnUrl;
        if (rdd.isIOS) {
            returnUrl = window.location.protocol + "//" + window.location.host + "/";
        } else {
            returnUrl = "null";
        }
        this.dispatchState({ InitBankID: { returnUrl: returnUrl, type: 'qr' } });
        this.setState({ BankIDBuzy: true, dialogDisabled: true, tab1Disabled: true, BankIDStep: 'otherDevice' });
    }
    render() {
        var locale = process.env.REACT_APP_DEFAULTLOCALE;
        var isSweden = false;
        var isNorway = false;
        if (locale.toLowerCase() === "nb-no") {
            isNorway = true;
        } else {
            isSweden = true;
        }

        const { classes } = this.props;
        const { t } = this.props;
        let { password } = this.state;
        const version = Version.getVersion();
        const server = this.state.ServerName ? this.state.ServerName : t('selfcare:info.connecting');
        const hideSnackbar = _ => {
            this.setState({ snackbarOpen: false });
        }
        return (<div>
            {this.state.redirect ? (<Redirect to={this.state.toUrl} />) : null}
            <Dialog
                open={this.state.InformationDialogOpen}
                onClose={this.handleInformationDialogClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle style={{ fontSize: '14px' }} id="responsive-dialog-title">{t('selfcare:title.welcomenewminside')}</DialogTitle>
                <DialogContent>
                    <div style={{ fontSize: '14px' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:dialog.newminsidenewpassword') }} /></div>
                </DialogContent>
                <DialogActions>
                    <ButtonX onClick={this.handleInformationDialogClose} color="rose">
                        {t('selfcare:button.ok')}
                        </ButtonX>
                </DialogActions>
            </Dialog>
            <Snackbar open={this.state.snackbarOpen} color="rose" message={this.state.snackbarMessage} place="tc" close={true} closeNotification={hideSnackbar} />
            <div className={classes.content}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem xs={10}>
                            <GridContainer justify="center">
                                <form onSubmit={(e) => this.handleLogin(e)}>
                                    <Card login className={classes[this.state.cardAnimaton]} style={{ maxWidth: '320px' }}>
                                        {this.state.Upgrade ?
                                            (
                                                <div>
                                                    <CardHeader
                                                        className={`${classes.cardHeader} ${classes.textCenter}`}
                                                        color="rose"
                                                    >
                                                        <img src={Logo} width={150} alt="Chilimobil" />
                                                        <h4 className={classes.cardTitle}>{t('selfcare:title.login')}</h4>
                                                        <div style={{ position: 'absolute', right: '5px', bottom: '1px', fontSize: '11px' }}>ver. {version}</div>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.newversion') }} />
                                                        <LinearProgress variant="query" />
                                                    </CardBody>
                                                </div>
                                            ) : null
                                        }
                                        {!this.state.Upgrade ?
                                            (<div><CardHeader
                                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                                color="rose"
                                            >
                                                <img src={Logo} width={150} alt="Chilimobil" />
                                                <h4 className={classes.cardTitle}>{t('selfcare:title.login')}</h4>
                                                <div style={{ position: 'absolute', right: '5px', bottom: '1px', fontSize: '11px' }}>{t('selfcare:info.ver')} {version}</div>
                                            </CardHeader>
                                                {isSweden &&
                                                    <Tabs style={{ margin: '20px' }} selectedIndex={this.state.tabIndex} onSelect={(index) => { this.indexChanged(index); }}>
                                                        <TabList>
                                                            <Tab disabled={this.state.tab1Disabled}>Mobilnummer</Tab>
                                                            <Tab>BankID</Tab>
                                                        </TabList>

                                                        <TabPanel>
                                                            <LoginMobileNumber classes={classes} t={t} password={password} state={this.state} usernameInput={this.usernameInput} passwordInput={this.passwordInput} navigateTo={this.navigateTo} hasLocalStorage={this.hasLocalStorage} handleChange={this.handleChange} changeUsername={this.changeUsername} changePassword={this.changePassword} />
                                                        </TabPanel>
                                                        <TabPanel style={{ width: '280px' }}>
                                                            {this.state.BankIDStep === 'start' &&
                                                                <CardBody style={{ padding: '0px', textAlign: 'center' }}>
                                                                    <img src={bankid} alt="Logga in med BankID" style={{ marginTop: '30px', marginBottom: '80px' }} />
                                                                    {!this.state.failureText &&
                                                                        <React.Fragment>
                                                                            {rdd.isMobile &&
                                                                                <React.Fragment>
                                                                                    <BankIdButton onClick={(event) => { this.initBankIDLocal(); }} variant="contained" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled} style={{ marginBottom: '10px' }}>
                                                                                        BankID på denna enhet
                                                                    </BankIdButton>
                                                                                    <BankIdButton onClick={(event) => { this.initBankIDOtherDevice(); }} variant="contained" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled}>
                                                                                        BankID på annan enhet
                                                                    </BankIdButton>
                                                                                </React.Fragment>
                                                                            }
                                                                            {!rdd.isMobile &&
                                                                                <React.Fragment>
                                                                                    <BankIdButton onClick={(event) => { this.initBankIDOtherDevice(); }} variant="contained" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled} style={{ marginBottom: '10px' }}>
                                                                                        Mobilt BankID
                                                                    </BankIdButton>
                                                                                    <BankIdButton onClick={(event) => { this.initBankIDLocal(); }} variant="contained" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled}>
                                                                                        BankID på denna enhet
                                                                    </BankIdButton>
                                                                                </React.Fragment>
                                                                            }
                                                                        </React.Fragment>}
                                                                    {this.state.failureText &&
                                                                        <React.Fragment>
                                                                            <Alert severity="error"><span style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: this.state.failureText }} /></Alert>
                                                                            <Button style={{ marginTop: '10px' }} variant="outlined" color="primary" size="large" fullWidth onClick={(event) => { this.dispatchState({ CancelBankID: true }); this.setState({ BankIDStep: 'start', tab1Disabled: false, QRValue: '', failureText: null }); }}>
                                                                                Försök igen
                                                                </Button>
                                                                        </React.Fragment>}
                                                                </CardBody>}
                                                            {this.state.BankIDStep === "otherDevice" &&
                                                                <CardBody style={{ padding: '0px', textAlign: 'center' }}>
                                                                    {this.state.startMessageText && !this.state.failureText &&
                                                                        <div style={{ marginBottom: '10px' }}>
                                                                            {this.state.startMessageText}
                                                                        </div>}
                                                                    {this.state.failureText &&
                                                                        <React.Fragment>
                                                                            <Alert severity="error"><span style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: this.state.failureText }} /></Alert>
                                                                            <Button style={{ marginTop: '10px' }} variant="outlined" color="primary" size="large" fullWidth onClick={(event) => { this.dispatchState({ CancelBankID: true }); this.setState({ BankIDStep: 'start', tab1Disabled: false, QRValue: '', failureText: null, startMessageText: null }); }}>
                                                                                Försök igen
                                                            </Button>
                                                                        </React.Fragment>}
                                                                    {(this.state.BankIDBuzy || this.state.startMessageText) && !this.state.failureText &&
                                                                        <div style={{ width: '280px' }}>
                                                                            <CircularProgress size={36} className={classes.bankIDProgress} />
                                                                        </div>}
                                                                    {!this.state.startMessageText && this.state.QRValue &&
                                                                        <React.Fragment>
                                                                            <div style={{ marginBottom: '10px', width: '280px' }}>
                                                                                Starta din BankID-app
                                                                    </div>
                                                                            <QRCode value={this.state.QRValue} size={200} />
                                                                            <div style={{ fontSize: '12px', marginBottom: '20px', marginTop: '10px' }}>
                                                                                Starta BankID-appen på din mobil eller surfplatta.<br />
                                                                        Klicka på QR-ikonen i appen och läs av QR-koden ovan.
                                                                    </div>
                                                                        </React.Fragment>}
                                                                    {!this.state.failureText && <Button variant="outlined" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled} onClick={(event) => { this.dispatchState({ CancelBankID: true }); this.setState({ BankIDStep: 'start', tab1Disabled: false, QRValue: '', failureText: null, startMessageText: null }); }}>
                                                                        Avbryt
                                                            </Button>}

                                                                </CardBody>}
                                                            {this.state.BankIDStep === "local" &&
                                                                <React.Fragment>
                                                                    {!rdd.isMobile && this.state.BankIDUrlSchema &&
                                                                        <iframe src={this.state.BankIDUrlSchema} width={0} height={0} frameBorder={0} />}
                                                                    <CardBody style={{ padding: '0px', textAlign: 'center' }}>
                                                                        {this.state.startMessageText && !this.state.failureText &&
                                                                            <div style={{ marginBottom: '10px' }}>
                                                                                {this.state.startMessageText}
                                                                            </div>}
                                                                        {this.state.failureText &&
                                                                            <React.Fragment>
                                                                                <Alert severity="error"><span style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: this.state.failureText }} /></Alert>
                                                                                <Button style={{ marginTop: '10px' }} variant="outlined" color="primary" size="large" fullWidth onClick={(event) => { this.dispatchState({ CancelBankID: true }); this.setState({ BankIDStep: 'start', tab1Disabled: false, QRValue: '', failureText: null, startMessageText: null }); }}>
                                                                                    Försök igen
                                                            </Button>
                                                                            </React.Fragment>}
                                                                        {!this.state.failureText && this.state.startMessageText &&
                                                                            <div style={{ width: '280px' }}>
                                                                                <CircularProgress size={36} className={classes.bankIDProgress} />
                                                                            </div>}

                                                                        {!this.state.failureText && !this.state.startMessageText &&
                                                                            <React.Fragment>
                                                                                <div>
                                                                                    Startar BankID appen
                                                                    </div>
                                                                                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                                                    <CircularProgress size={36} className={classes.bankIDProgress} />
                                                                                </div>
                                                                                <BankIdButton href={this.state.BankIDUrlSchema} variant="contained" color="primary" size="large" fullWidth disabled={this.state.dialogDisabled}>
                                                                                    Öppna BankID
                                                                    </BankIdButton>


                                                                                <Button style={{ marginTop: '10px' }} variant="outlined" color="primary" size="large" fullWidth onClick={(event) => { this.dispatchState({ CancelBankID: true }); this.setState({ BankIDStep: 'start', tab1Disabled: false, QRValue: '' }); }}>
                                                                                    Avbryt inloggning
                                                                </Button>
                                                                            </React.Fragment>}
                                                                    </CardBody>
                                                                </React.Fragment>}
                                                        </TabPanel>
                                                    </Tabs>}
                                                {isNorway &&

                                                    <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '15px' }}>
                                                        <LoginMobileNumber classes={classes} t={t} password={password} state={this.state} usernameInput={this.usernameInput} passwordInput={this.passwordInput} navigateTo={this.navigateTo} hasLocalStorage={this.hasLocalStorage} handleChange={this.handleChange} changeUsername={this.changeUsername} changePassword={this.changePassword} />
                                                    </div>}

                                            </div>) : null}


                                    </Card>
                                    <div style={{ maxWidth: '330px', position: 'relative', top: '-440px', padding: '10px', display: this.state.SelfcareDisabled ? 'block' : 'none' }}>
                                        <img src={Board} style={{ maxWidth: '320px' }} alt="" />
                                        <div style={{ position: 'relative', top: '-255px', left: '25px', width: '270px', height: '180px', color: 'white', fontStyle: 'Italic' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700 }} dangerouslySetInnerHTML={{ __html: this.state.SelfcareDisabledTitle }} />
                                            <div dangerouslySetInnerHTML={{ __html: this.state.SelfcareDisabledMessage }} />
                                        </div>
                                    </div>
                                </form>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </div>
                <Footer />
            </div>
        </div>

        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired,
    onAuthenticated: PropTypes.func
};

export default compose(
    withStyles(loginPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, LoginPage));
